import { render, staticRenderFns } from "./contentContainer.vue?vue&type=template&id=1f248fa4&scoped=true&"
import script from "./contentContainer.vue?vue&type=script&lang=js&"
export * from "./contentContainer.vue?vue&type=script&lang=js&"
import style0 from "./contentContainer.vue?vue&type=style&index=0&id=1f248fa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f248fa4",
  null
  
)

export default component.exports